import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';



export interface DropDownInput {
  searchFieldName : string,keyFieldName? : string;
  address?:string
}

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css']
})
export class DropDownComponent implements OnChanges{


  qry : string="";
  clicked : boolean=false;
  showDropDown : boolean=false;
  filteredList : any[]=[];

  @Input()
  params : DropDownInput = {searchFieldName:""};

  @Input()
  list : any[]=[];
  

  @Input()
  modelInput : any;

  @Output()
  onSelectItem! : EventEmitter<any>;
  @Output()
  onInput! : EventEmitter<any>;

  _selectItemIdx:number = -1;



  constructor() {
    this.onSelectItem=new EventEmitter<any>();
    this.onInput=new EventEmitter<any>();
    this.qry=this.modelInput;
    //this._filter();
  }


  ngOnChanges(changes: SimpleChanges): void {
    
    if(changes['list']) {

      this.selectInitPassedValue();
      
      //this._filter();
    } 
    if(changes["modelInput"]){

      this._selectItemIdx=-1;
      this.qry=this.modelInput;
      this.onInput.emit({text:this.qry});
    }
    
  }

  selectInitPassedValue() {
    if(this.params.keyFieldName) {
      if(this.modelInput) {
        const itm = this.list.find((itm : any) => itm[this.params.keyFieldName as string]==this.modelInput);
        if(itm) {
          //this.qry=itm[this.params.searchFieldName];
          //this._filter();
        }
      } else {
        //this.qry="";
      }
    }
  }
  /*_filter() {
    if(this.list) {
      const _data = [...this.list];
      if(this.qry) {
        this.filteredList=_data.filter(itm => itm[this.params.searchFieldName]?.toLowerCase()?.includes(this.qry?.toLowerCase() as string));
      } else {
        this.filteredList=_data;
      }
    } else {
      this.filteredList=[];
    }
    this._selectItemIdx = -1;


  }*/

  selectItem(itm : any,emitEvent : boolean) {
    // console.log('sdfddf')
    this.qry=itm[this.params.searchFieldName];
    this.showDropDown=false;

    if(emitEvent) this.onSelectItem.emit(itm);

  }

  onFocusInputBox() {
    this.showDropDown=true;
    //this._filter();
  }

  onInputBoxKeyDown(e : any) {
    if (e.code === 'ArrowDown' || e.keyCode === 40) { 
      if(this._selectItemIdx==(this.list.length-1)) {
        this._selectItemIdx=0;
      } else {
        this._selectItemIdx=this._selectItemIdx+1;
      }
    } else if (e.code === 'ArrowUp' || e.keyCode === 38) { 
      if(this._selectItemIdx==0) {
        this._selectItemIdx=(this.filteredList.length-1);
      } else {
        this._selectItemIdx=this._selectItemIdx-1;
      }
    } else if(e.code==='Enter' || e.keyCode===13) {
      this.selectItem(this.list[this._selectItemIdx],true);
      this._selectItemIdx=-1;
    }

    // console.log("selected index === " + this._selectItemIdx);
   

  }
  

  onTextInput() {
    this.onInput.emit({text : this.qry});
  }

  onBlurEmpPosFiterSearchDropDown() {
    setTimeout(() => {
      if(!this.clicked) {
        const items = [...this.list.filter(itm => itm[this.params.searchFieldName]?.toLowerCase()==this.qry?.toLocaleLowerCase() as string)]
        if(items && items.length>0) {
          this.selectItem(items[0],true);
        } else {
          this.selectItem({},true);
        }
      }
    }, 100); // allow time for click/mousedown to register
    
  }

}
